/* eslint-disable */
//

import moment from "moment"
import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

import {
    euRegion,
    federalAndStates,
    federalRegions,
    internationalRegions,
    localRegions,
    stateRegions,
    usRegions,
} from "shared/imports/regionConstants"

import { MAX_BILL_SEARCHIFY_SELECTIONS } from "shared/search/constants"

import Filter from "shared/search/containers/Filter/index"

import { isValidAmountString } from "shared/imports/sharedHelperFunctions"
import { generatePreviousToCurrentYearsEnumItems } from "shared/search/helperFunctions"

import { selectFilterValue, selectShowManuallyChangedInListFilter } from "shared/search/selectors"
import { selectStancesWithCustomLabels } from "shared/stance/selectors"

import AddressInputFilter from "app/static/frontend/search-new/components/Filter/AddressInputFilter/AddressInputFilter"
import DatePickerFilter from "app/static/frontend/search-new/components/Filter/DatePickerFilter/DatePickerFilter"
import EnumFilter from "app/static/frontend/search-new/components/Filter/EnumFilter/EnumFilter"
import HorizontalRuleFilter from "app/static/frontend/search-new/components/Filter/HorizontalRuleFilter/HorizontalRuleFilter"
import SearchBarFilterComponent from "app/static/frontend/search-new/components/Filter/SearchBarFilter/SearchBarFilter"
import SearchifySelectFilter from "app/static/frontend/search-new/components/Filter/SearchifySelectFilter/SearchifySelectFilter"
import SingleFilter from "app/static/frontend/search-new/components/Filter/SingleFilter/SingleFilter"
import TextInputFilter from "app/static/frontend/search-new/components/Filter/TextInputFilter/TextInputFilter"
import TripletFilter from "app/static/frontend/search-new/components/Filter/TripletFilter/TripletFilter"

import {
    ActionCenterSettingsSearchifyFLV,
    AmendmentFilterableListView,
    BillFilterableListView,
    BulkEmailFilterableListView,
    CampaignFilterableListView,
    CommitteeFilterableListView,
    CountrySearchifyFLV,
    CountySearchifyFLV,
    DistrictSearchifyFLV,
    ElectionFilterableListView,
    IssueManagementFilterableListView,
    IssueSearchifyFLV,
    LegislativeSessionSearchifyFLV,
    LowerLDSearchifyFLV,
    MunicipalitySearchifyFLV,
    NewListFilterableListView,
    PressContactFilterableListView,
    StateSearchifyFLV,
    SupporterFilterableListView,
    TeamSearchifyFLV,
    TransactionFilterableListView,
    UpperLDSearchifyFLV,
    UserFilterableListView,
    VoteFilterableListView,
    OfficialFilterableWithoutCampaignFinanceListView,
    PublicOrganizationFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

// we're importing selects into shared and stubbing the file path in the mobile
// .babelrc.
import {
    AccountBankSelect,
    ActionCenterSettingsSelect,
    AmendmentSelect,
    BillSelect,
    BulkEmailSelect,
    CampaignSelect,
    CommitteeSelect,
    ContactSelect,
    CountryEUSelect,
    CountrySelect,
    CountySelect,
    CustomRegionSelectionSelect,
    DistrictSelect,
    ElectionSelect,
    IssueManagementSelect,
    IssueSelect,
    LedgerSettingsSelect,
    LegSessionSelect,
    ListSelect,
    LowerDistrictSelect,
    MunicipalitySelect,
    PacSelect,
    PressContactSelect,
    StateSelect,
    TeamSelect,
    TransactionBatchSelect,
    TransactionSelect,
    UpperDistrictSelect,
    UserSelect,
    VoteSelect,
    OfficialWithoutCampaignFinanceSelect,
    SchoolDistrictSelect,
} from "app/static/frontend/selects/containers/PieSelect"

import {
    CustomChosenOptionsTagSelect,
    DateListNoFutureSelect,
    DateListNoPastSelect,
    DateListSelect,
    PopulationRangesSelect,
    TransactionMethodTypeSelect,
} from "app/static/frontend/selects/containers/EnumSelect"

import { DateRangePicker } from "app/static/frontend/components/DateRangePicker"
import { isFeatureEnabled } from "shared/featureflags/helperFunctions"
import { PRIORITY_FILTER_KEY, STANCE_FILTER_KEY } from "shared/imports/sharedConstants"

import { multiGenericFilter } from "shared/search/containers/Filter/FilterCreators"
import {
    enumOrderDescendingSort,
    GenericFilter,
    searchifySelectGenericFilter,
    toggleGenericFilter,
    enumGenericFilter,
    createSelectToggleMultiFilter,
} from "shared/search/containers/Filter/FilterCreators"

export interface FilterComponentProps {
    filterComponent: (...args: any[]) => JSX.Element
    subfilters: Component<FilterComponentProps>[]
    filterValue: any
}

/** ***************************************************************************
 *
 * All sorts of default set-ups for filters!
 *
 ***************************************************************************** */

export class enumBillGlobalStatusFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        presentationComponent: EnumFilter,
        serialize: (values) => {
            if (!values) return ""

            const statusEnum = DjangIO.app.bill.status.GeneralBillStatus
            const enumItems = [
                DjangIO.app.bill.status.GeneralBillStatus.global_introduced,
                DjangIO.app.bill.status.GeneralBillStatus.global_in_progress,
                DjangIO.app.bill.status.GeneralBillStatus.global_adopted,
            ]
            let resultStatuses = []

            for (const item of enumItems) {
                if (values.includes(item.value)) {
                    resultStatuses.push(
                        ...statusEnum.items().filter((status) => status.global_status === item.global_status),
                    )
                }
            }
            return resultStatuses.map((status) => status.value).join(",")
        },
        // if it's a string that represents a number, parse it into an int!
        // otherwise, it's a string value.
        deserialize: (value) => (value ? value.split(",").map((key) => (isNaN(key) ? key : parseInt(key))) : []),
        serializationKey: "enumGlobalStatus",
    }

    render() {
        return <GenericFilter {...this.props} />
    }
}

export class enumRegulationGlobalStatusFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        presentationComponent: EnumFilter,
        serialize: (values) => {
            if (!values) return ""

            const statusEnum = DjangIO.app.reg.types.GeneralRegStatus
            const enumItems = [
                DjangIO.app.reg.types.GeneralRegStatus.global_proposed,
                DjangIO.app.reg.types.GeneralRegStatus.global_adopted,
            ]
            let resultStatuses = []

            for (const item of enumItems) {
                if (values.includes(item.value)) {
                    resultStatuses.push(
                        ...statusEnum.items().filter((status) => status.global_status === item.global_status),
                    )
                }
            }
            return resultStatuses.map((status) => status.value).join(",")
        },
        // if it's a string that represents a number, parse it into an int!
        // otherwise, it's a string value.
        deserialize: (value) => (value ? value.split(",").map((key) => (isNaN(key) ? key : parseInt(key))) : []),
        serializationKey: "enumGlobalStatus",
    }

    render() {
        return <GenericFilter {...this.props} />
    }
}

export class enumSingleGenericFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        presentationComponent: EnumFilter,
        // it will take an array from the EnumFilter.
        serialize: (value) =>
            value &&
            value.length &&
            // app/static/frontend/search-new/components/Filter/EnumFilter/EnumFilter.js
            // updateSelect
            // can return [undefined] when we render a enumSingleGenericFilter with an associated
            // selectComponent (such as DateListNoFutureSelect) because the select
            // "x" clear button returns undefined rather than ""
            value.filter((item) => item !== undefined).length
                ? value[0].toString()
                : "",
        // if it's a string that represents a number, parse it into an int!
        // this is for Enum values. Otherwise, it's a slugified custom field option,
        // which should always be a string, so leave it as a string!
        deserialize: (value) => (value ? (isNaN(value) ? value : parseInt(value)) : null),
        serializationKey: "enumSingle",
        multi: false,
    }

    render() {
        return <GenericFilter {...this.props} />
    }
}

export const enumValueSort = (a, b) => a.value - b.value
export const enumValueDescendingSort = (a, b) => b.value - a.value
export const enumOrderSort = (a, b) => {
    const isNullish = (order) => order == null

    if (!(isNullish(a.order) || isNullish(b.order))) return a.order - b.order
    // prioritize items with a defined order
    if (!isNullish(a.order)) return -1
    if (!isNullish(b.order)) return 1

    return 0
}

export const enumLabelSort = (a, b) => a.label.localeCompare(b.label)

// Label sort specific to Language enum - English always first then the rest alphabetical
export const enumLangLabelSort = (a, b) => {
    const englishLabel = DjangIO.app.document.types.Language.english.label
    const otherLabel = DjangIO.app.document.types.Language.other.label
    if (a.label == englishLabel || b.label == englishLabel || a.label == otherLabel || b.label == otherLabel) {
        if (a.order && b.order) return b.order - a.order
        else return a.order ? -1 : 1
    } else {
        return a.label.localeCompare(b.label)
    }
}

export const enumPrecedenceSort = (a, b) => (a.precedence || 0) - (b.precedence || 0)

export class textGenericFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        presentationComponent: TextInputFilter,
        serialize: (value) => value,
        deserialize: (value) => value,
        serializationKey: "text",
    }

    render() {
        return <GenericFilter {...this.props} />
    }
}

export class textAmountGenericFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        presentationComponent: TextInputFilter,
        serialize: (value) => (value ? value.replace(/\$/g, "") : null),
        deserialize: (value) => (value ? value.replace(/\$/g, "") : null),
        serializationKey: "text",
    }

    render() {
        return <GenericFilter {...this.props} />
    }
}

export class singleToggleGenericFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        presentationComponent: SingleFilter,
        serialize: (value) => (value != null ? value.toString() : ""),
        deserialize: (value) => (value ? value === "true" : null),
        serializationKey: "toggle",
    }

    render() {
        return <GenericFilter {...this.props} />
    }
}

export class tripletGenericFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        presentationComponent: TripletFilter,
        serializationKey: "triplet",
        serialize: (value) => value,
        deserialize: (value) => value,
    }

    render() {
        return <GenericFilter {...this.props} />
    }
}

export class searchifySelectZipCodesFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        presentationComponent: SearchifySelectFilter,
        serialize: (value) => {
            return JSON.stringify(value)
        },
        deserialize: (value) => {
            if (!value) {
                return {}
            }
            return JSON.parse(value)
        },
        serializationKey: "select",
    }
    render() {
        return <GenericFilter {...this.props} />
    }
}

export const getSerializedDateValue = (value, filterKey) => {
    // somewhat dumb serialization because it involves just rearranging the date string,
    // but the component renders the string in one format and the API wants the date in another
    // some attrs such as "created" in Vote dataset uses a DateTimeField
    // which requires a time being specified to correctly exclude the selected date
    const apiDateFormat = "YYYY-MM-DD HH:mm:ss"
    const mobileDateFormat = "MMMM Do, YYYY"
    if (filterKey) {
        if (filterKey.includes("__lt")) {
            if (typeof value === "object") {
                // then it's a date object from webapp
                return moment(value).startOf("day").format(apiDateFormat)
            } else {
                // it's a string from mobile
                return moment(value, mobileDateFormat).startOf("day").format(apiDateFormat)
            }
        } else if (filterKey.includes("__gt")) {
            if (typeof value === "object") {
                return moment(value).endOf("day").format(apiDateFormat)
            } else {
                return moment(value, mobileDateFormat).endOf("day").format(apiDateFormat)
            }
        }
    }
    if (typeof value === "object") {
        return moment(value).format("YYYY-MM-DD")
    } else {
        return moment(value, mobileDateFormat).format("YYYY-MM-DD")
    }
}

export class dateRangePickerFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        presentationComponent: DateRangePicker,
        serialize: (value) => value || null,
        deserialize: (value) => value || null,
        serializationKey: "dates",
    }
    render() {
        return <GenericFilter {...this.props} />
    }
}

export class datePickerGenericFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        presentationComponent: DatePickerFilter,
        serialize: (value, filterKey) => {
            if (value) {
                return getSerializedDateValue(value, filterKey)
            }
        },
        // We need to explicitly treat the date filters in the UTC timezone
        // otherwise the date will be deserialized in the Eastern timezone with a UTC date which produces incorrect PDF donwloads
        deserialize: (value) => (value ? moment.utc(value, "YYYY-MM-DD") : undefined),
        serializationKey: "date",
    }

    render() {
        return <GenericFilter {...this.props} />
    }
}

export class hrGenericFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        presentationComponent: HorizontalRuleFilter,
    }

    render() {
        return <GenericFilter {...this.props} />
    }
}

export class addressGenericFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        presentationComponent: AddressInputFilter,
        serialize: (value) => value,
        deserialize: (value) => value,
        serializationKey: "address",
    }

    render() {
        return <GenericFilter {...this.props} />
    }
}

const filterComponents = [
    GenericFilter,
    enumGenericFilter,
    enumSingleGenericFilter,
    textGenericFilter,
    singleToggleGenericFilter,
    tripletGenericFilter,
    searchifySelectGenericFilter,
    datePickerGenericFilter,
    addressGenericFilter,
]

export const serializeFunctions = filterComponents.reduce((acc, filter) => {
    acc[filter.defaultProps.serializationKey] = filter.defaultProps.serialize
    return acc
}, {})
export const deserializeFunctions = filterComponents.reduce((acc, filter) => {
    acc[filter.defaultProps.serializationKey] = filter.defaultProps.deserialize
    return acc
}, {})

export function generateCustomTagFilter(customTag) {
    switch (customTag.tag_type) {
        case DjangIO.app.person.types.TagType.boolean.value: {
            return class CustomBooleanFilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: toggleGenericFilter,
                    uniqueFilterId: customTag.slug,
                    filterKey: `tag_dict__${customTag.slug}`,
                    displayLabel: customTag.name,
                    trueText: "Yes",
                    falseText: "No",
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }
        }

        case DjangIO.app.person.types.TagType.single_option_list.value: {
            // options might be null, must account for that!
            let formattedOptions

            const options = customTag.options_new || {}
            formattedOptions = Object.keys(options)
                .filter((optKey) => !options[optKey].archived)
                .map((optKey) => ({
                    value: optKey,
                    label: options[optKey].value,
                    order: options[optKey].order,
                }))

            return class CustomSingleOptionFilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: enumGenericFilter,
                    uniqueFilterId: customTag.slug,
                    filterKey: `tag_dict__${customTag.slug}__in`,
                    enumItems: formattedOptions,
                    displayLabel: customTag.name,
                    selectComponent: CustomChosenOptionsTagSelect,
                    sortBy: enumOrderSort,
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }
        }

        case DjangIO.app.person.types.TagType.multi_options_list.value: {
            // options might be null, must account for that!
            let formattedOptions
            const options = customTag.options_new || {}
            formattedOptions = Object.keys(options)
                .filter((optKey) => !options[optKey].archived)
                .map((optKey) => ({
                    value: optKey,
                    label: options[optKey].value,
                    order: options[optKey].order,
                }))

            return class CustomMultiOptionFilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: enumGenericFilter,
                    uniqueFilterId: customTag.slug,
                    filterKey: `tag_dict__${customTag.slug}__overlaps`,
                    enumItems: formattedOptions,
                    displayLabel: customTag.name,
                    selectComponent: CustomChosenOptionsTagSelect,
                    sortBy: enumOrderSort,
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }
        }

        case DjangIO.app.person.types.TagType.date.value:
            return [
                class CustomDatePickerStartFilter extends Component<FilterComponentProps> {
                    static defaultProps = {
                        filterComponent: datePickerGenericFilter,
                        uniqueFilterId: `${customTag.slug}Start`,
                        filterKey: `tag_dict__${customTag.slug}__gt`,
                        displayLabel: `${customTag.name} After`,
                    }
                    render() {
                        const FilterComponent = this.props.filterComponent
                        return <FilterComponent {...this.props} />
                    }
                },
                class CustomDatePickerEndFilter extends Component<FilterComponentProps> {
                    static defaultProps = {
                        filterComponent: datePickerGenericFilter,
                        uniqueFilterId: `${customTag.slug}End`,
                        filterKey: `tag_dict__${customTag.slug}__lt`,
                        displayLabel: `${customTag.name} Before`,
                    }
                    render() {
                        const FilterComponent = this.props.filterComponent
                        return <FilterComponent {...this.props} />
                    }
                },
            ]

        case DjangIO.app.person.types.TagType.number.value:
            return createNumericTripletMultiFilter({
                uniqueFilterId: customTag.slug,
                baseFilterKey: `tag_dict__${customTag.slug}`,
                displayLabel: customTag.name,
            })

        default:
            // default to rendering string filter!
            return class CustomTextFilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: textGenericFilter,
                    uniqueFilterId: customTag.slug,
                    filterKey: `tag_dict__${customTag.slug}__icontains`,
                    displayLabel: customTag.name,
                    placeholderText: "Search here...",
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }
    }
}

export function generateAlignmentTypeFilter({ alignmentTypes, uniqueFilterId, filterKey }) {
    return class AlignmentTypeFilter extends Component<FilterComponentProps> {
        static defaultProps = {
            filterComponent: enumGenericFilter,
            uniqueFilterId,
            filterKey,
            enumItems: alignmentTypes,
            displayLabel: `Alignment`,
            sortBy: enumOrderDescendingSort,
        }

        render() {
            const FilterComponent = this.props.filterComponent
            return <FilterComponent {...this.props} />
        }
    }
}

export function generateGrassrootsActionCenterFilter({ uniqueFilterId, filterKey }) {
    return class GrassrootsActionCenterFilter extends Component<FilterComponentProps> {
        static get defaultProps() {
            return {
                filterComponent: searchifySelectGenericFilter,
                uniqueFilterId,
                filterKey,
                searchifyFLV: ActionCenterSettingsSearchifyFLV,
                dataTypeLabel: "Action Centers",
                displayLabel: "Choose multiple action centers...",
                selectComponent: ActionCenterSettingsSelect,
            }
        }

        render() {
            const FilterComponent = this.props.filterComponent
            return <FilterComponent {...this.props} />
        }
    }
}

export const generateGrassrootsActionCampaignFilter = (actionCenter) => {
    const GACampaignFilter = (props) => {
        const FilterComponent = props.filterComponent
        return <FilterComponent {...props} />
    }
    GACampaignFilter.defaultProps = {
        filterComponent: searchifySelectGenericFilter,
        uniqueFilterId: "gaCampaignFilter",
        filterKey: "for_campaigns",
        searchifyFLV: CampaignFilterableListView,
        dataTypeLabel: "Campaigns",
        selectComponent: CampaignSelect,
        displayLabel: "Participated in campaigns...",
        searchifyPermanentFilter: {
            ...(actionCenter ? { action_center__in: actionCenter } : {}),
        },
    }

    return GACampaignFilter
}

export const generateGANotInCampaignFilter = (actionCenter) => {
    const GANotInCampaignFilter = (props) => {
        const FilterComponent = props.filterComponent
        return <FilterComponent {...props} />
    }
    GANotInCampaignFilter.defaultProps = {
        filterComponent: searchifySelectGenericFilter,
        uniqueFilterId: "gaNotInCampaignFilter",
        filterKey: "not_for_campaigns",
        searchifyFLV: CampaignFilterableListView,
        dataTypeLabel: "Campaigns",
        selectComponent: CampaignSelect,
        displayLabel: "Not participated in campaigns...",
        searchifyPermanentFilter: {
            ...(actionCenter ? { action_center__in: actionCenter } : {}),
        },
    }

    return GANotInCampaignFilter
}

export function generateGamificationLevelFilter(actionCenter) {
    const enumItems = Object.entries(actionCenter.gamification_tiers).map(
        ([tierName, tierProps]: [string, { points: number }]) => ({
            key: tierName,
            label: tierName,
            value: `${actionCenter.id};${tierProps.points}`,
            order: tierProps.points,
        }),
    )

    return class GamificationLevelFilter extends Component<FilterComponentProps> {
        static defaultProps = {
            filterComponent: enumGenericFilter,
            uniqueFilterId: `gamification-level-${actionCenter.id}`,
            filterKey: "reached_gamification_level",
            enumItems,
            displayLabel: `${actionCenter.name} Level`,
            sortBy: enumOrderSort,
        }

        render() {
            const FilterComponent = this.props.filterComponent
            return <FilterComponent {...this.props} />
        }
    }
}

/**
 * This returns a filter set that includes a enum dropdown list, a enum select dropdown, and a toggle filter
 * The selected values from the two enum filters are combined together, works like multi-select
 * the filterKey is based on the selected value of the toggle filter
 *
 * Params that differs between the list and select dropdown filters:
 * @param {Object} enumItems - the options for the enum list filter
 * @param {Object} enumSelectItems - the options for the enum select dropdown filter
 * @param {Function} enumSortBy - sorting method for the enum list filter
 * @param {Function} enumSelectSortBy - sorting method for the enum select dropdown filter
 */
export const createEnumToggleMultiFilter = (args) =>
    class SelectToggleMultiFilter extends Component<FilterComponentProps> {
        static get defaultProps() {
            const toggleId = `${args.uniqueFilterId}MultiToggle`
            const enumId = `${args.uniqueFilterId}Enum`
            // need to have different ID for the selected values to be rendered in the right filter
            const enumSelectId = `${args.uniqueFilterId}EnumSelect`

            const toggle = class ToggleSubfilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: toggleGenericFilter,
                    displayLabel: args.toggleDisplayLabel,
                    uniqueFilterId: toggleId,
                    // since the filterKey is based on the selected toggle value
                    // this field will be computed from computeFilterValueFromSubfilters()
                    filterKey: "",
                    trueText: args.toggleTextMapping.trueText,
                    falseText: args.toggleTextMapping.falseText,
                    initialValue: "true",
                    isNullable: false,
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }

            // the enum list filter
            const generateEnum = class EnumSubFilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: enumGenericFilter,
                    uniqueFilterId: enumId,
                    filterKey: "",
                    enumItems: args.enumItems,
                    sortBy: args.enumSortBy,
                    displayKey: args.displayKey,
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }

            // the enum select dropdown filter
            const generateEnumSelect = class EnumSubFilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: enumGenericFilter,
                    displayLabel: args.selectDisplayLabel,
                    uniqueFilterId: enumSelectId,
                    filterKey: "",
                    enumItems: args.enumSelectItems,
                    selectComponent: args.selectComponent,
                    sortBy: args.enumSelectSortBy,
                    displayKey: args.displayKey,
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }

            return {
                ...args,
                filterComponent: multiGenericFilter,
                uniqueFilterId: args.uniqueFilterId,
                displayLabel: args.displayLabel,
                subfilters: [generateEnum, generateEnumSelect, toggle],
                allFilterKeys: Object.values(args.filterKeyMapping),
                computeFilterKeyFromSubfilters: (filters) =>
                    filters.get(toggleId) != null ? args.filterKeyMapping[filters.get(toggleId)] : "",
                // This lets us build the query string from the values in redux
                // it combines the values from both enum list and enum select dropdown
                computeFilterValueFromSubfilters: (filters) => {
                    if (filters.get(enumId) && filters.get(enumSelectId)) {
                        return filters.get(enumId) + "," + filters.get(enumSelectId)
                    } else if (filters.get(enumSelectId)) {
                        return filters.get(enumSelectId)
                    }
                    return filters.get(enumId)
                },
                // This lets us build the values in the redux store from the query string
                // assign the selected value to the right filter that has the value as their option
                computeSubfilterValuesFromParent: (filterKey, value) => {
                    const enumOptions = args.enumItems.map((item) => (item.value ? item.value.toString() : item))
                    const enumValue = value
                        .split(",")
                        .filter((v) => enumOptions.includes(v))
                        .join(",")
                    const enumSelectOptions = args.enumSelectItems.map((item) =>
                        item.value ? item.value.toString() : item,
                    )
                    const enumSelectValue = value
                        .split(",")
                        .filter((v) => enumSelectOptions.includes(v))
                        .join(",")

                    return {
                        [toggleId]: Object.keys(args.filterKeyMapping).find(
                            (key) => args.filterKeyMapping[key] === filterKey,
                        ),
                        [enumId]: enumValue,
                        [enumSelectId]: enumSelectValue,
                    }
                },
                serializationKey: enumGenericFilter.defaultProps.serializationKey,
            }
        }

        render() {
            const FilterComponent = this.props.filterComponent
            return <FilterComponent {...this.props} />
        }
    }

export const createTransactionAmountFilter = (args) => {
    const uniqueFilterId = `${args.quorumDataType.key}TransactionAmountFilter`
    const transactionId = `${uniqueFilterId}MultiPieSelectTransaction`
    const dateGteId = `${uniqueFilterId}MultiDateAmountGte`
    const dateLteId = `${uniqueFilterId}MultiDateAmountLte`
    const dateExcludeGteId = `${uniqueFilterId}MultiDateAmountExcludeGte`
    const dateExcludeLteId = `${uniqueFilterId}MultiDateAmountExcludeLte`
    const amountGteId = `${uniqueFilterId}MultiNumberInputAmountGte`
    const amountLteId = `${uniqueFilterId}MultiNumberInputAmountLte`
    const bankAccountId = `${uniqueFilterId}MultiPieSelectBankAccount`
    const electionId = `${uniqueFilterId}MultiPieSelectElection`
    const methodTypeId = `${uniqueFilterId}MultiEnumMethodType`
    const batchId = `${uniqueFilterId}MultiPieSelectBatch`
    const referenceNumberId = `${uniqueFilterId}MultiNumberInputReferenceNumber`
    const payrollFrequencyTypeId = `${uniqueFilterId}MultiEnumPayrollFrequencyType`
    const hasContributedId = `${uniqueFilterId}SingleToggleHasContributed`
    const labelNewContributorId = `${uniqueFilterId}LabelNewContributor`
    const serializationKey = "generic"

    const getDefaultProps = () => {
        const getDisplayLabelExtraTransactionType = () => {
            if (
                [
                    DjangIO.app.models.QuorumDataType.person.value,
                    DjangIO.app.models.QuorumDataType.political_committee.value,
                    DjangIO.app.models.QuorumDataType.election.value,
                ].includes(args.quorumDataType.value)
            ) {
                return "Disbursement"
            } else if (
                [
                    DjangIO.app.models.QuorumDataType.supporter.value,
                    DjangIO.app.models.QuorumDataType.transaction.value,
                ].includes(args.quorumDataType.value)
            ) {
                return "Receipt"
            }
        }
        const DateGteFilter = class TransactionDatePickerStartFilter extends Component<FilterComponentProps> {
            static defaultProps = {
                filterComponent: datePickerGenericFilter,
                uniqueFilterId: dateGteId,
                filterKey: "",
                displayLabel: "Date From",
                isSubSubfilter: true,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const DateLteFilter = class TransactionDatePickerEndFilter extends Component<FilterComponentProps> {
            static defaultProps = {
                filterComponent: datePickerGenericFilter,
                uniqueFilterId: dateLteId,
                filterKey: "",
                displayLabel: "Date To",
                isSubSubfilter: true,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }
        const DateExcludeGteFilter = class TransactionDateExcludePickerStartFilter extends Component<FilterComponentProps> {
            static defaultProps = {
                filterComponent: datePickerGenericFilter,
                uniqueFilterId: dateExcludeGteId,
                filterKey: "",
                displayLabel: "First Contribution",
                isSubSubfilter: true,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const DateExcludeLteFilter = class TransactionDateExcludePickerEndFilter extends Component<FilterComponentProps> {
            static defaultProps = {
                filterComponent: datePickerGenericFilter,
                uniqueFilterId: dateExcludeLteId,
                filterKey: "",
                displayLabel: "Last Contribution",
                isSubSubfilter: true,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const AmountGteFilter = class TransactionAmountGreaterFilter extends Component<FilterComponentProps> {
            static defaultProps = {
                filterComponent: textGenericFilter,
                uniqueFilterId: amountGteId,
                filterKey: "",
                displayLabel: "Amount Min",
                errorMessage: "Please enter a valid number amount.",
                keyboardType: "numeric",
                placeholderText: "$0.00",
                shouldValidateInput: true,
                validateTextInput: isValidAmountString,
                isSubSubfilter: true,
                shouldSubmitOnChange: true,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const AmountLteFilter = class TransactionAmountLessFilter extends Component<FilterComponentProps> {
            static defaultProps = {
                filterComponent: textGenericFilter,
                uniqueFilterId: amountLteId,
                filterKey: "",
                placeholderText: "$0.00",
                displayLabel: "Amount Max",
                keyboardType: "numeric",
                shouldValidateInput: true,
                validateTextInput: isValidAmountString,
                errorMessage: "Please enter a valid number amount.",
                isSubSubfilter: true,
                shouldSubmitOnChange: true,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const BankAccountFilter = class TransactionBankAccountFilter extends Component<FilterComponentProps> {
            static get defaultProps() {
                return {
                    filterComponent: searchifySelectGenericFilter,
                    uniqueFilterId: bankAccountId,
                    filterKey: "",
                    dataTypeLabel: "Bank Account",
                    displayLabel: "Bank Account",
                    selectComponent: AccountBankSelect,
                    invisible: !args.hasMultipleBankAccounts,
                }
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const ElectionFilter = class ElectionFilter extends Component<FilterComponentProps> {
            static get defaultProps() {
                return {
                    filterComponent: searchifySelectGenericFilter,
                    uniqueFilterId: electionId,
                    filterKey: "",
                    searchifyFLV: ElectionFilterableListView,
                    selectComponent: ElectionSelect,
                    displayLabel: "Search Elections",
                    searchifyPermanentFilter: {
                        for_transactions: args.quorumDataType.value,
                    },
                }
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const MethodTypeFilter = class TransactionMethodTypeFilter extends Component<FilterComponentProps> {
            static defaultProps = {
                filterComponent: enumGenericFilter,
                uniqueFilterId: methodTypeId,
                filterKey: "",
                enumItems: DjangIO.app.ledger.types.TransactionMethodType.region_supported_items().filter(
                    (transactionMethodType) => transactionMethodType.is_primary,
                ),
                sortBy: enumValueSort,
                displayLabel: "Common Payment Methods",
            }
            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const MethodTypeSelectFilter = class TransactionMethodTypeSelectFilter extends Component<FilterComponentProps> {
            static defaultProps = {
                filterComponent: enumGenericFilter,
                uniqueFilterId: methodTypeId,
                filterKey: "",
                // As Stripe payment methods will be deprecated - and probably removed from the codebase - we are just
                // removing the options from the list on this ticket
                // https://quorumanalytics.atlassian.net/browse/QPE-2072
                enumItems: DjangIO.app.ledger.types.TransactionMethodType.region_supported_items().filter(
                    (transactionMethodType) => !transactionMethodType.search_label.includes("Stripe"),
                ),
                sortBy: enumValueSort,
                selectComponent: TransactionMethodTypeSelect,
                displayLabel: "Other Payment Methods",
            }
            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const BatchFilter = class TransactionBatchAccountFilter extends Component<FilterComponentProps> {
            static get defaultProps() {
                return {
                    filterComponent: searchifySelectGenericFilter,
                    uniqueFilterId: batchId,
                    filterKey: "",
                    dataTypeLabel: "Batch",
                    displayLabel: "Batch",
                    selectComponent: TransactionBatchSelect,
                }
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const ReferenceNumberFilter = class TransactionReferenceNumberFilter extends Component<FilterComponentProps> {
            static get defaultProps() {
                return {
                    filterComponent: textGenericFilter,
                    uniqueFilterId: referenceNumberId,
                    // transaction_reference_number
                    filterKey: "",
                    placeholderText: "Choose a reference #...",
                    displayLabel: "Reference Number",
                }
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const PayrollFrequencyTypeFilter = class TransactionPayrollFrequencyTypeFilter extends Component<FilterComponentProps> {
            static defaultProps = {
                filterComponent: enumGenericFilter,
                uniqueFilterId: payrollFrequencyTypeId,
                // payroll_frequency_type__in
                filterKey: "",
                enumItems: DjangIO.app.ledger.types.PayrollFrequencyType.region_supported_items(),
                displayLabel: "Payroll Frequency",
                sortBy: enumValueSort,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const getDisplayLabelHasContributed = () => {
            if (
                [
                    DjangIO.app.models.QuorumDataType.person.value,
                    DjangIO.app.models.QuorumDataType.political_committee.value,
                    DjangIO.app.models.QuorumDataType.election.value,
                ].includes(args.quorumDataType.value)
            ) {
                return "Disbursed Money"
            } else if (
                [
                    DjangIO.app.models.QuorumDataType.supporter.value,
                    DjangIO.app.models.QuorumDataType.transaction.value,
                ].includes(args.quorumDataType.value)
            ) {
                return "Has Contributed"
            }
        }
        const HasContributedFilter = class TransactionHasContributedFilter extends Component<FilterComponentProps> {
            static defaultProps = {
                filterComponent: toggleGenericFilter,
                uniqueFilterId: hasContributedId,
                filterKey: "",
                displayLabel: getDisplayLabelHasContributed(),
                falseText: "No",
                isNullable: true,
                trueText: "Yes",
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const TransactionFilter = class TransactionFilter extends Component<FilterComponentProps> {
            static get defaultProps() {
                return {
                    filterComponent: searchifySelectGenericFilter,
                    uniqueFilterId: transactionId,
                    filterKey: "",
                    searchifyFLV: TransactionFilterableListView,
                    selectComponent: TransactionSelect,
                    displayLabel: "Search Transactions",
                    searchifyPermanentFilter: {
                        ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.supporter.value
                            ? { supporter__isnull: false }
                            : {}),
                        ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.political_committee.value
                            ? { committee__isnull: false }
                            : {}),
                        ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.person.value
                            ? { committee__candidate__isnull: false }
                            : {}),
                        ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.election.value
                            ? { election__isnull: false }
                            : {}),
                    },
                }
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const HorizontalRuleFilter = class TransactionHorizontalRuleFilter extends Component<FilterComponentProps> {
            static defaultProps = {
                filterComponent: hrGenericFilter,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const LabelFilter = class TransactionLabelFilter extends Component<FilterComponentProps> {
            static defaultProps = {
                filterComponent: enumGenericFilter,
                ...(args.quorumDataType.value !== DjangIO.app.models.QuorumDataType.transaction.value
                    ? {
                          displayLabel: `Search for ${
                              args.quorumDataType.plural
                          } with an Aggregate ${getDisplayLabelExtraTransactionType()} Total`,
                      }
                    : {}),
                invisible: true,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const LabelNewContributorFilter = class TransactionLabelNewContributorFilter extends Component<FilterComponentProps> {
            static defaultProps = {
                filterComponent: enumGenericFilter,
                displayLabel: "Search for New Contributors",
                uniqueFilterId: labelNewContributorId,
                invisible: true,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const amountColumn =
            args.quorumDataType.value === DjangIO.app.models.QuorumDataType.transaction.value ? "amount" : "sum"

        const getSubFilters = () => {
            const canViewDisbursementsOrReceipts =
                !isFeatureEnabled("ff_pac_permissions_one") ||
                Userdata.can_view_pac_receipts ||
                Userdata.can_view_pac_disbursements

            const canViewBothDisbursementsAndReceipts =
                !isFeatureEnabled("ff_pac_permissions_one") ||
                (Userdata.can_view_pac_receipts && Userdata.can_view_pac_disbursements)

            const isContactDatasetWithViewReceipts =
                !isFeatureEnabled("ff_pac_permissions_one") ||
                (args.quorumDataType.value === DjangIO.app.models.QuorumDataType.supporter.value &&
                    Userdata.can_view_pac_receipts)

            const isPoliticalCommitteeDatasetWithViewDisbursement =
                !isFeatureEnabled("ff_pac_permissions_one") ||
                (args.quorumDataType.value === DjangIO.app.models.QuorumDataType.political_committee.value &&
                    Userdata.can_view_pac_disbursements)

            if (
                canViewBothDisbursementsAndReceipts ||
                isContactDatasetWithViewReceipts ||
                isPoliticalCommitteeDatasetWithViewDisbursement
            ) {
                return [
                    ...(args.quorumDataType.value !== DjangIO.app.models.QuorumDataType.transaction.value
                        ? [HasContributedFilter, HorizontalRuleFilter, LabelFilter]
                        : []),
                    [DateGteFilter, DateLteFilter],
                    [LabelNewContributorFilter],
                    ...(args.quorumDataType.value !== DjangIO.app.models.QuorumDataType.transaction.value
                        ? [[DateExcludeGteFilter, DateExcludeLteFilter]]
                        : []),
                    [AmountGteFilter, AmountLteFilter],
                    BankAccountFilter,
                    ...([
                        DjangIO.app.models.QuorumDataType.person.value,
                        DjangIO.app.models.QuorumDataType.political_committee.value,
                    ].includes(args.quorumDataType.value)
                        ? [ElectionFilter]
                        : []),
                    ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.transaction.value
                        ? [BatchFilter, ReferenceNumberFilter]
                        : []),
                    MethodTypeFilter,
                    MethodTypeSelectFilter,
                    ...([
                        DjangIO.app.models.QuorumDataType.transaction.value,
                        DjangIO.app.models.QuorumDataType.supporter.value,
                    ].includes(args.quorumDataType.value)
                        ? [PayrollFrequencyTypeFilter]
                        : []),
                    ...(args.quorumDataType.value !== DjangIO.app.models.QuorumDataType.transaction.value
                        ? [HorizontalRuleFilter, TransactionFilter]
                        : []),
                ]
            }

            if (canViewDisbursementsOrReceipts) {
                return [
                    ...(args.quorumDataType.value !== DjangIO.app.models.QuorumDataType.transaction.value
                        ? [TransactionFilter]
                        : []),
                ]
            }

            return []
        }

        return {
            ...args,
            allFilterKeys: ["transactions__amount"],
            filterComponent: multiGenericFilter,
            uniqueFilterId,
            serializationKey: serializationKey,
            // actually defined in
            // shared/search/containers/FilterGroup/SupporterPACFilterGroup.js
            // connectedFilterGroup => defaultProps => filterKeyMap
            filterKey: "transactions__amount",
            subfilters: getSubFilters(),
            computeFilterKeyFromSubfilters: (filters) => "transactions__amount",
            computeFilterValueFromSubfilters: (filters) => {
                const hasContributed = filters.get(hasContributedId)
                const dateGte = filters.get(dateGteId)
                const dateLte = filters.get(dateLteId)
                const dateExcludeGte = filters.get(dateExcludeGteId)
                const dateExcludeLte = filters.get(dateExcludeLteId)
                const amountGte = filters.get(amountGteId)
                const amountLte = filters.get(amountLteId)
                const bankAccount = filters.get(bankAccountId)
                const election = filters.get(electionId)
                const methodType = filters.get(methodTypeId)
                const batch = filters.get(batchId)
                const referenceNumber = filters.get(referenceNumberId)
                const payrollFrequencyType = filters.get(payrollFrequencyTypeId)
                const transaction = filters.get(transactionId)

                if (
                    !hasContributed &&
                    !dateGte &&
                    !dateLte &&
                    !dateExcludeGte &&
                    !dateExcludeLte &&
                    !amountGte &&
                    !amountLte &&
                    !bankAccount &&
                    !election &&
                    !methodType &&
                    !batch &&
                    !referenceNumber &&
                    !payrollFrequencyType &&
                    !transaction
                ) {
                    return undefined
                }

                const params = {} as Record<string, any>
                if (dateGte) {
                    params.occurred_date__gte = dateGte
                }
                if (dateLte) {
                    params.occurred_date__lte = dateLte
                }

                if (args.quorumDataType.value !== DjangIO.app.models.QuorumDataType.transaction.value) {
                    if (dateExcludeGte) {
                        params.occurred_date_exclude__gte = dateExcludeGte
                    }
                    if (dateExcludeLte) {
                        params.occurred_date_exclude__lte = dateExcludeLte
                    }
                }

                if (amountGte) {
                    params[`${amountColumn}__gte`] = amountGte * 100
                }
                if (amountLte) {
                    params[`${amountColumn}__lte`] = amountLte * 100
                }
                if (bankAccount) {
                    params.bank_accounts__in = bankAccount
                }
                if (election) {
                    params.election__in = election
                }
                if (methodType) {
                    params.transaction_method__in = methodType
                }

                if (args.quorumDataType.value === DjangIO.app.models.QuorumDataType.transaction.value) {
                    if (batch) {
                        params.batch__in = batch
                    }
                    if (referenceNumber) {
                        params.reference_number__in = referenceNumber
                    }
                }

                if (args.quorumDataType.value !== DjangIO.app.models.QuorumDataType.transaction.value) {
                    if (hasContributed) {
                        params.has_contributed = hasContributed
                    }
                    if (transaction) {
                        params.id__in = transaction
                    }
                }

                if (
                    [
                        DjangIO.app.models.QuorumDataType.transaction.value,
                        DjangIO.app.models.QuorumDataType.supporter.value,
                    ].includes(args.quorumDataType.value)
                ) {
                    if (payrollFrequencyType) {
                        params.payroll_frequency_type__in = payrollFrequencyType
                    }
                }

                return JSON.stringify(params)
            },
            computeSubfilterValuesFromParent: (filterKey, value) => {
                const data = JSON.parse(value)

                return {
                    [dateGteId]: data.occurred_date__gte,
                    [dateLteId]: data.occurred_date__lte,
                    ...(args.quorumDataType.value !== DjangIO.app.models.QuorumDataType.transaction.value
                        ? {
                              [dateExcludeGteId]: data.occurred_date_exclude__gte,
                              [dateExcludeLteId]: data.occurred_date_exclude__lte,
                          }
                        : {}),
                    [amountGteId]: data[`${amountColumn}__gte`] / 100,
                    [amountLteId]: data[`${amountColumn}__lte`] / 100,
                    [bankAccountId]: data.bank_accounts__in,
                    ...([
                        DjangIO.app.models.QuorumDataType.person.value,
                        DjangIO.app.models.QuorumDataType.political_committee.value,
                    ].includes(args.quorumDataType.value)
                        ? {
                              [electionId]: data.election__in,
                          }
                        : {}),
                    [methodTypeId]: data.transaction_method__in,
                    ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.transaction.value
                        ? {
                              [batchId]: data.batch__in,
                              [referenceNumberId]: data.reference_number__in,
                          }
                        : {}),
                    ...(args.quorumDataType.value !== DjangIO.app.models.QuorumDataType.transaction.value
                        ? {
                              [hasContributedId]: data.has_contributed,
                              [transactionId]: data.id__in,
                          }
                        : {}),
                    ...([
                        DjangIO.app.models.QuorumDataType.transaction.value,
                        DjangIO.app.models.QuorumDataType.supporter.value,
                    ].includes(args.quorumDataType.value)
                        ? {
                              [payrollFrequencyTypeId]: data.payroll_frequency_type__in,
                          }
                        : {}),
                }
            },
        }
    }

    const defaultProps = getDefaultProps()
    class UnconnectedTransactionAmountFilter extends Component<FilterComponentProps> {
        static get defaultProps() {
            return defaultProps
        }

        render() {
            const FilterComponent = this.props.filterComponent
            return (
                <FilterComponent
                    {...this.props}
                    subfilters={this.props.subfilters
                        .map((subfilter) => {
                            if (Array.isArray(subfilter)) {
                                return subfilter.filter((subsubfilter) => {
                                    if (
                                        [dateExcludeGteId, dateExcludeLteId, labelNewContributorId].includes(
                                            subsubfilter.defaultProps.uniqueFilterId,
                                        ) &&
                                        ((this.props.filterValue &&
                                            !this.props.filterValue.includes("occurred_date")) ||
                                            !this.props.filterValue ||
                                            // only render for Quorum employees since
                                            // Kristen and UX need to potentially make changes
                                            // TODO: remove this once necessary UX changes are made
                                            !isFeatureEnabled("ff_qpac_new_contributors"))
                                    ) {
                                        return false
                                    }

                                    return true
                                })
                            }

                            return subfilter
                        })
                        .filter((subfilter) => (Array.isArray(subfilter) ? subfilter.length : subfilter))}
                />
            )
        }
    }

    const TransactionAmountFilter = connect(createStructuredSelector({ filterValue: selectFilterValue }))(
        UnconnectedTransactionAmountFilter,
    )
    // TODO: Resolve this issue - the ignore-error is TEMPORARY
    // @ts-expect-error - defaultProps doesn't actually exist on the class
    TransactionAmountFilter.defaultProps = defaultProps

    return TransactionAmountFilter
}

export const createPacContributionTotalFilter = (args) =>
    class PacContributionTotalFilter extends Component<FilterComponentProps> {
        static get defaultProps() {
            const inputId = `${args.uniqueFilterId}MultiNumberInput`
            const tripletId = `${args.uniqueFilterId}MultiTriplet`
            const yearId = `${args.uniqueFilterId}YearFilter`

            const yearFilter = class YearFilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: enumGenericFilter,
                    uniqueFilterId: yearId,
                    filterKey: "",
                    enumItems: generatePreviousToCurrentYearsEnumItems(),
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }

            const amountInput = class InputFilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: textGenericFilter,
                    uniqueFilterId: inputId,
                    filterKey: "",
                    placeholderText: "Enter an amount...",
                    keyboardType: "numeric",
                    shouldValidateInput: true,
                    validateTextInput: isValidAmountString,
                    errorMessage: "Please enter a valid number amount.",
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }

            const triplet = class TripletFilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: tripletGenericFilter,
                    uniqueFilterId: tripletId,
                    filterKey: "",
                    initialValue: "right",
                    isNullable: false,
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }

            return {
                ...args,
                filterComponent: multiGenericFilter,
                uniqueFilterId: args.uniqueFilterId,
                displayLabel: args.displayLabel,
                filterKey: "",
                subfilters: [amountInput, triplet, yearFilter],
                computeFilterKeyFromSubfilters: (filters) => "supporter_contribution_total",
                computeFilterValueFromSubfilters: (filters) => {
                    const amount = filters.get(inputId)
                    const filter = filters.get(tripletId)
                    const years = filters.get(yearId)
                    if (!amount && !years) {
                        return undefined
                    }
                    return JSON.stringify({
                        amount,
                        filter,
                        years,
                    })
                },
                computeSubfilterValuesFromParent: (filterKey, value) => {
                    const data = JSON.parse(value)
                    return {
                        [inputId]: data.amount,
                        [tripletId]: data.filter,
                        [yearId]: data.years,
                    }
                },
                serializationKey: "toggle",
            }
        }

        render() {
            const FilterComponent = this.props.filterComponent
            return <FilterComponent {...this.props} />
        }
    }

export const createCustomToggleFilter = (args) =>
    class CustomToggleFilter extends Component<FilterComponentProps> {
        static get defaultProps() {
            const toggleId = `${args.uniqueFilterId}CustomToggle`

            const toggle = class ToggleSubfilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: toggleGenericFilter,
                    uniqueFilterId: toggleId,
                    filterKey: "",
                    trueText: "Yes",
                    falseText: "No",
                    isNullable: true,
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }

            return {
                ...args,
                filterComponent: multiGenericFilter,
                uniqueFilterId: args.uniqueFilterId,
                displayLabel: args.displayLabel,
                subfilters: [toggle],
                allFilterKeys: Object.values(args.filterKeyMapping),
                computeFilterKeyFromSubfilters: (filters) =>
                    filters.get(toggleId) != null ? args.filterKeyMapping[filters.get(toggleId)] : "",
                computeFilterValueFromSubfilters: (filters) =>
                    filters.get(toggleId) != null ? args.valueMapping[filters.get(toggleId)] : "",
                // This lets us build the values in the redux store from the query string
                computeSubfilterValuesFromParent: (filterKey, value) => {
                    return {
                        [toggleId]: Object.keys(args.filterKeyMapping).find(
                            (key) => args.filterKeyMapping[key] === filterKey,
                        ),
                    }
                },
                serializationKey: "numeric",
                serialize: (value) => value,
                deserialize: (value) => parseInt(value),
            }
        }

        render() {
            const FilterComponent = this.props.filterComponent
            return <FilterComponent {...this.props} />
        }
    }

export const createNumericTripletMultiFilter = (args) =>
    class NumericTripletMultiFilter extends Component<FilterComponentProps> {
        static get defaultProps() {
            let filterKeyMapDefault = {}
            const inputId = `${args.uniqueFilterId}MultiNumberInput`
            const tripletId = `${args.uniqueFilterId}MultiTriplet`

            if (args.baseFilterKey) {
                filterKeyMapDefault = {
                    left: `${args.baseFilterKey}__lt`,
                    center: `${args.baseFilterKey}__exact`,
                    right: `${args.baseFilterKey}__gt`,
                }
            }

            const filterKeyMapping = args.filterKeyMapping || filterKeyMapDefault

            const input = class InputFilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: textGenericFilter,
                    uniqueFilterId: inputId,
                    filterKey: "",
                    placeholderText: "Enter a number...",
                    keyboardType: "numeric",
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }

            const triplet = class TripletFilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: tripletGenericFilter,
                    uniqueFilterId: tripletId,
                    filterKey: "",
                    initialValue: "center",
                    isNullable: false,
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }

            return {
                ...args,
                filterComponent: multiGenericFilter,
                uniqueFilterId: args.uniqueFilterId,
                displayLabel: args.displayLabel,
                filterKey: "",
                subfilters: [input, triplet],
                allFilterKeys: Object.values(filterKeyMapping),
                computeFilterKeyFromSubfilters: (filters) =>
                    filterKeyMapping[filters.get(tripletId)] ? filterKeyMapping[filters.get(tripletId)] : undefined,
                computeFilterValueFromSubfilters: (filters) => filters.get(inputId),
                computeSubfilterValuesFromParent: (filterKey, value) => {
                    return {
                        [inputId]: value,
                        [tripletId]:
                            Object.keys(filterKeyMapping).find((key) => filterKey.includes(filterKeyMapping[key])) ||
                            "center",
                    }
                },
                serializationKey: "numeric",
                serialize: (value) => value,
                deserialize: (value) => parseInt(value),
            }
        }

        render() {
            const FilterComponent = this.props.filterComponent
            return <FilterComponent {...this.props} />
        }
    }

export const createProfileToggleFilter = (args) =>
    class ProfileToggleFilter extends Component<FilterComponentProps> {
        static get defaultProps() {
            const toggleId = `${args.uniqueFilterId}MultiToggle`

            const toggle = (subprops) => {
                const FilterComponent = subprops.filterComponent
                return <FilterComponent {...subprops} />
            }

            toggle.defaultProps = {
                filterComponent: toggleGenericFilter,
                uniqueFilterId: toggleId,
                filterKey: "",
                trueText: args.trueText,
                falseText: args.falseText,
            }

            return {
                ...args,
                filterComponent: multiGenericFilter,
                uniqueFilterId: args.uniqueFilterId,
                subfilters: [toggle],
                allFilterKeys: Object.values(args.filterKeyMapping),
                computeFilterKeyFromSubfilters: (filters) =>
                    filters.get(toggleId) != null ? args.filterKeyMapping[filters.get(toggleId)] : "",
                // specified instead of 'computeFilterValueFromSubfilters' --
                // we'll get the profileID in FilterableListView/index instead!
                computeFilterValueFromProfileId: true,
                computeSubfilterValuesFromParent: (filterKey, value) => ({
                    [toggleId]: Object.keys(args.filterKeyMapping).find(
                        (key) => args.filterKeyMapping[key] === filterKey,
                    ),
                }),
                serializationKey: textGenericFilter.defaultProps.serializationKey,
            }
        }

        render() {
            const FilterComponent = this.props.filterComponent
            return <FilterComponent {...this.props} />
        }
    }

export const createProfileToggleSingleFilter = (args) =>
    class ProfileToggleFilter extends Component<FilterComponentProps> {
        static get defaultProps() {
            const toggleId = `${args.uniqueFilterId}SingleToggle`

            const toggle = (subprops) => {
                const FilterComponent = subprops.filterComponent
                return <FilterComponent {...subprops} />
            }

            toggle.defaultProps = {
                filterComponent: singleToggleGenericFilter,
                uniqueFilterId: toggleId,
                filterKey: "",
                trueText: args.trueText,
            }

            return {
                ...args,
                filterComponent: multiGenericFilter,
                uniqueFilterId: args.uniqueFilterId,
                subfilters: [toggle],
                allFilterKeys: Object.values(args.filterKeyMapping),
                computeFilterKeyFromSubfilters: (filters) =>
                    filters.get(toggleId) != null ? args.filterKeyMapping[filters.get(toggleId)] : "",
                // specified instead of 'computeFilterValueFromSubfilters' --
                // we'll get the profileID in FilterableListView/index instead!
                computeFilterValueFromProfileId: true,
                computeSubfilterValuesFromParent: (filterKey, value) => ({
                    [toggleId]: Object.keys(args.filterKeyMapping).find(
                        (key) => args.filterKeyMapping[key] === filterKey,
                    ),
                }),
                serializationKey: textGenericFilter.defaultProps.serializationKey,
            }
        }

        render() {
            const FilterComponent = this.props.filterComponent
            return <FilterComponent {...this.props} />
        }
    }

/** ***************************************************************************
 *
 * SearchBarFilter is going to go everywhere!
 *
 ***************************************************************************** */

export class SearchBarFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: GenericFilter,
        uniqueFilterId: "AdvancedSearchFilter",
        componentKey: "bar", // disambiguate during rendering, since uniqueFilterId is shared
        filterKey: "advanced_search",
        presentationComponent: SearchBarFilterComponent,
        placeholderText: "Search here...",
        searchBar: true, // this is used for styling
        isProtected: true,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

// this is used if we want to search profiles.
export class AdvancedSearchFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "AdvancedSearchFilter",
        componentKey: "profiles", // disambiguate during rendering, since uniqueFilterId is shared
        filterKey: "advanced_search",
        placeholderText: "Search...",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AiSearchFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "AiSearchFilter",
        filterKey: "ai_search",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

/** ***************************************************************************
 *
 * General, reusable filters!
 *
 ***************************************************************************** */

export interface CreateRegionFilterConfig {
    regions?: number[]
    displayLabel?: string
    shouldShowFunc?: (...args: any[]) => any
}

export interface RegionFilterProps {
    filterComponent?: any
    uniqueFilterId?: string
    filterKey?: string
    regions?: readonly number[]
    searchifyFLV?: string
    dataTypeLabel?: string
    selectComponent?: (...args: any[]) => any
    shouldShowFunc?: (...args: any[]) => any
}

export const createRegionFilter = (configs: CreateRegionFilterConfig = {}, regionFilterKey = "for_regions") => {
    const RegionFilter = (props: RegionFilterProps) => {
        const FilterComponent = props.filterComponent || searchifySelectGenericFilter
        return <FilterComponent searchifyFLV={StateSearchifyFLV} {...props} />
    }
    RegionFilter.defaultProps = {
        filterComponent: searchifySelectGenericFilter,
        uniqueFilterId: "region",
        filterKey: regionFilterKey,
        regions: configs.regions || (usRegions as readonly number[]),
        dataTypeLabel: "States",
        displayLabel: configs.displayLabel,
        shouldShowFunc:
            configs.shouldShowFunc || (() => !Userdata.isSingleStateMode() || !Userdata.isSingleLocalMode()),
        selectComponent: StateSelect,
    }

    return RegionFilter
}

export const RegionFilter = createRegionFilter()
export const StateRegionFilter = createRegionFilter({}, "for_states")
// @ts-expect-error TS doesn't like concatenating readonly types
export const RegionNoFederalFilter = createRegionFilter({ regions: stateRegions.concat(localRegions) })

export const CustomRegionFilter = (props) => {
    const FilterComponent = props.filterComponent

    return <FilterComponent {...props} />
}
CustomRegionFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "customRegionFilter",
    filterKey: "for_custom_regions",
    selectComponent: CustomRegionSelectionSelect,
    dataTypeLabel: "Custom Regions",
    regions: stateRegions,
}

export const RegionCountryEUFilter = (props) => {
    const FilterComponent = props.filterComponent

    return <FilterComponent searchifyFLV={CountrySearchifyFLV} {...props} />
}
RegionCountryEUFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "regionCountryEUFilter",
    filterKey: "for_countries",
    selectComponent: CountryEUSelect,
    searchifyPermanentFilter: { only_eu_countries: true },
    dataTypeLabel: "Countries",
    regions: euRegion,
}

export const RegionCountryFilter = (props) => {
    const FilterComponent = props.filterComponent

    return <FilterComponent searchifyFLV={CountrySearchifyFLV} {...props} />
}
RegionCountryFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "regionCountryFilter",
    filterKey: "for_countries",
    dataTypeLabel: "Countries",
    selectComponent: CountrySelect,
    regions: internationalRegions,
}

export const RepresentingCountryAllFilter = (props) => {
    const FilterComponent = props.filterComponent

    return <FilterComponent searchifyFLV={CountrySearchifyFLV} {...props} />
}
RepresentingCountryAllFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "reppingCountry",
    filterKey: "representing_country",
    dataTypeLabel: "Countries",
    selectComponent: CountrySelect,
}

export class DateListNoFutureFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: enumSingleGenericFilter,
        uniqueFilterId: "dateListFilter",
        filterKey: "date_range",
        componentKey: "no-future", // disambiguate during rendering since uniqueFilterId is shared
        enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
            (item) =>
                !(
                    [
                        DjangIO.app.events.models.DateRangeType.future.value,
                        DjangIO.app.events.models.DateRangeType.next_month.value,
                        DjangIO.app.events.models.DateRangeType.next_week.value,
                    ] as number[]
                ).includes(item.value),
        ),
        sortBy: enumOrderSort,
        selectComponent: DateListNoFutureSelect,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DateListNoPastFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: enumSingleGenericFilter,
        uniqueFilterId: "dateListFilter",
        filterKey: "date_range",
        componentKey: "no-past", // disambiguate during rendering since uniqueFilterId is shared
        enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
            (item) =>
                !(
                    [
                        DjangIO.app.events.models.DateRangeType.this_week.value,
                        DjangIO.app.events.models.DateRangeType.this_month.value,
                        DjangIO.app.events.models.DateRangeType.this_quarter.value,
                        DjangIO.app.events.models.DateRangeType.this_year.value,
                        DjangIO.app.events.models.DateRangeType.yesterday.value,
                        DjangIO.app.events.models.DateRangeType.this_week_exclusive.value,
                    ] as number[]
                ).includes(item.value),
        ),
        sortBy: enumOrderSort,
        selectComponent: DateListNoPastSelect,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DateListFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: enumSingleGenericFilter,
        uniqueFilterId: "dateListFilter",
        filterKey: "date_range",
        enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items(),
        sortBy: enumOrderSort,
        selectComponent: DateListSelect,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const createDateListFilter = (enumItems) => {
    const GeneratedDateListFilter = (props) => <DateListFilter {...props} enumItems={enumItems} />

    GeneratedDateListFilter.defaultProps = DateListFilter.defaultProps
    return GeneratedDateListFilter
}

export class DatePickerStartFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "dateStart",
        filterKey: "date__gt",
        displayLabel: "Start Date",
        helpText: "Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DatePickerEndFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "dateEnd",
        filterKey: "date__lt",
        displayLabel: "End Date",
        helpText: "Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const DatePickerStartNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
DatePickerStartNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "dateStartNoFuture",
    filterKey: "date__gt",
    displayLabel: "Start Date",
    noFuture: true,
    helpText: "Excludes date selected.",
}

export const DatePickerEndNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
DatePickerEndNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "dateEndNoFuture",
    filterKey: "date__lt",
    displayLabel: "End Date",
    noFuture: true,
    helpText: "Excludes date selected.",
}

export class RepresentingStateFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "reppingState",
            filterKey: "representing_state",
            dataTypeLabel: "States",
            regions: usRegions,
            searchifyFLV: StateSearchifyFLV,
            selectComponent: StateSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class RepresentingDistrictFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "reppingDistrict",
            filterKey: "representing_district",
            dataTypeLabel: "Districts",
            regions: federalRegions,
            searchifyFLV: DistrictSearchifyFLV,
            selectComponent: DistrictSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class RepresentingDistrictPrimaryFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "reppingDistrictPrimary",
            filterKey: "representing_district_primary",
            dataTypeLabel: "Districts",
            displayLabel: "Legislative Representatives",
            regions: federalRegions,
            searchifyFLV: DistrictSearchifyFLV,
            selectComponent: DistrictSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class RepresentingUpperLDFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "reppingUpperLD",
            filterKey: "representing_upper_district",
            dataTypeLabel: "Upper Legislative Districts",
            regions: stateRegions,
            searchifyFLV: UpperLDSearchifyFLV,
            selectComponent: UpperDistrictSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class RepresentingUpperLDPrimaryFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "reppingUpperLDPrimary",
            filterKey: "representing_upper_district_primary",
            dataTypeLabel: "Upper Legislative Districts",
            regions: stateRegions,
            searchifyFLV: UpperLDSearchifyFLV,
            selectComponent: UpperDistrictSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class RepresentingLowerLDFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "reppingLowerLD",
            filterKey: "representing_lower_district",
            dataTypeLabel: "Lower Legislative Districts",
            regions: stateRegions,
            searchifyFLV: LowerLDSearchifyFLV,
            selectComponent: LowerDistrictSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class RepresentingLowerLDPrimaryFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "reppingLowerLDPrimary",
            filterKey: "representing_lower_district_primary",
            dataTypeLabel: "Lower Legislative Districts",
            regions: stateRegions,
            searchifyFLV: LowerLDSearchifyFLV,
            selectComponent: LowerDistrictSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class RepresentingCountyFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "reppingCounty",
            filterKey: "representing_county",
            dataTypeLabel: "Counties",
            regions: usRegions,
            searchifyFLV: CountySearchifyFLV,
            selectComponent: CountySelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class RepresentingMunicipalityFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "reppingMunicipality",
            filterKey: "representing_municipality",
            dataTypeLabel: "Towns and Cities",
            regions: usRegions,
            searchifyFLV: MunicipalitySearchifyFLV,
            selectComponent: MunicipalitySelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class RepresentingSchoolDistrictFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "reppingSchoolDistrict",
            filterKey: "searchify_puborg",
            dataTypeLabel: "School District",
            regions: localRegions,
            searchifyFLV: PublicOrganizationFilterableListView,
            selectComponent: SchoolDistrictSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const createSchoolDistrictEnrollmentFilter = (config: {
    uniqueFilterId: string
    filterKey: string
    isMin: boolean
}) => {
    return class SchoolDistrictEnrollmentFilter extends Component<FilterComponentProps> {
        static get defaultProps() {
            return {
                filterComponent: textGenericFilter,
                displayLabel: config.isMin ? "Minimum Enrollment Size" : "Maximum Enrollment Size",
                uniqueFilterId: config.uniqueFilterId,
                filterKey: config.filterKey,
                placeholderText: config.isMin ? "0" : "100000",
                keyboardType: "numeric",
                shouldValidateInput: true,
                validateTextInput: isValidAmountString,
                errorMessage: "Please enter a valid number.",
            }
        }

        render() {
            const FilterComponent = this.props.filterComponent
            return <FilterComponent {...this.props} />
        }
    }
}

export class RepresentingZipCodeFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: GenericFilter,
            uniqueFilterId: "reppingZipCode",
            filterKey: "representing_zip_code",
            presentationComponent: TextInputFilter,
            placeholderText: "Search zip code...",
            displayLabel: "Zip Code Lookup",
            keyboardType: "numeric",
            regions: usRegions,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignedToMeFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "assignedToMeFilter",
        trueText: "Me",
        falseText: "Others",
        filterKey: "assigned_to_me",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class NotAssignedToMeFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "notAssignedToMeFilter",
        trueText: "Me",
        falseText: "Others",
        filterKey: "not_assigned_to_me",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignedToUserFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "assignedToUserFilter",
            filterKey: "assigned_to",
            displayLabel: "Is assigned to...",
            dataTypeLabel: "Users",
            searchifyFLV: UserFilterableListView,
            selectComponent: UserSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignedToSupporterFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "assignedToSupporterFilter",
            filterKey: "assigned_to_supporter",
            dataTypeLabel: "Contacts",
            searchifyFLV: SupporterFilterableListView,
            selectComponent: ContactSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class NotAssignedToUserFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "notAssignedToUserFilter",
            filterKey: "not_assigned_to",
            displayLabel: "Is not assigned to...",
            dataTypeLabel: "Users",
            searchifyFLV: UserFilterableListView,
            selectComponent: UserSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class NotAssignedToSupporterFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "notAssignedToSupporterFilter",
            filterKey: "not_assigned_to_supporter",
            dataTypeLabel: "Contacts",
            searchifyFLV: SupporterFilterableListView,
            selectComponent: ContactSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignmentOrderByCreatorNameFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "assignmentOrderByCreatorNameFilter",
        filterKey: "order_by_creator_name",
        displayLabel: "Creator Last Name",
        trueText: "Ascending",
        falseText: "Descending",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignmentOrderByUserNameFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "assignmentOrderByUserNameFilter",
        filterKey: "order_by_user_name",
        displayLabel: "Assignee User Last Name",
        trueText: "Ascending",
        falseText: "Descending",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignmentOrderByContactNameFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "assignmentOrderByContactNameFilter",
        filterKey: "order_by_contact_name",
        displayLabel: "Assignee Contact Last Name",
        trueText: "Ascending",
        falseText: "Descending",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignmentOrderByAmendmentTitleFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "assignmentOrderByAmendmentTitleFilter",
        filterKey: "order_by_amendment_title",
        displayLabel: "Associated Amendment Title",
        permissions: [DjangIO.app.models.PermissionType.legislative_profiles],
        trueText: "Ascending",
        falseText: "Descending",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignmentOrderByBillTitleFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "assignmentOrderByBillTitleFilter",
        filterKey: "order_by_bill_title",
        displayLabel: "Associated Bill Title",
        permissions: [DjangIO.app.models.PermissionType.legislative_profiles],
        trueText: "Ascending",
        falseText: "Descending",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignmentOrderByCustomEventNameFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "assignmentOrderByCustomEventNameFilter",
        filterKey: "order_by_custom_event_name",
        displayLabel: "Associated Custom Event Name",
        permissions: [DjangIO.app.models.PermissionType.custom_events],
        trueText: "Ascending",
        falseText: "Descending",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignmentOrderByDocketTitleFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "assignmentOrderByDocketTitleFilter",
        filterKey: "order_by_docket_title",
        displayLabel: "Associated Docket Title",
        permissions: [DjangIO.app.models.PermissionType.regulations],
        trueText: "Ascending",
        falseText: "Descending",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignmentOrderByOfficialLastnameFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "assignmentOrderByPersonLastnameFilter",
        filterKey: "order_by_member_lastname",
        displayLabel: "Associated Official Lastname",
        permissions: [DjangIO.app.models.PermissionType.legislators],
        trueText: "Ascending",
        falseText: "Descending",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignmentOrderByProjectNameFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "assignmentOrderByProjectNameFilter",
        filterKey: "order_by_project_name",
        displayLabel: "Associated Project Name",
        permissions: [DjangIO.app.models.PermissionType.project_management],
        trueText: "Ascending",
        falseText: "Descending",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignmentOrderByPublicOrganizationNameFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "assignmentOrderByPublicOrganizationNameFilter",
        filterKey: "order_by_public_organization_name",
        displayLabel: "Associated Public Organization Name",
        trueText: "Ascending",
        falseText: "Descending",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignmentOrderByRegulationTitleFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "assignmentOrderByRegulationTitleFilter",
        filterKey: "order_by_regulation_title",
        displayLabel: "Associated Regulation Title",
        permissions: [DjangIO.app.models.PermissionType.regulations],
        trueText: "Ascending",
        falseText: "Descending",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignmentOrderBySupporterLastnameFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "assignmentOrderBySupporterLastnameFilter",
        filterKey: "order_by_supporter_lastname",
        displayLabel: "Associated Contact Lastname",
        permissions: [DjangIO.app.models.PermissionType.custom_contacts],
        trueText: "Ascending",
        falseText: "Descending",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignmentOrderByVoteQuestionFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "assignmentOrderByVoteQuestionFilter",
        filterKey: "order_by_vote_question",
        displayLabel: "Associated Vote Question",
        permissions: [DjangIO.app.models.PermissionType.legislative_data],
        trueText: "Ascending",
        falseText: "Descending",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class HasAssignmentTripletFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        const uniqueFilterId = "hasAssignmentTripletFilter"
        const tripletId = `${uniqueFilterId}MultiTriplet`

        const filterKeyMapping = {
            left: "is_assigned",
            center: "is_assigned",
            right: "has_more_than_one_assignment",
        }

        const valueMapping = {
            left: "false",
            center: "true",
            right: "true",
        }

        const triplet = class TripletFilter extends Component<FilterComponentProps> {
            static defaultProps = {
                filterComponent: tripletGenericFilter,
                uniqueFilterId: tripletId,
                filterKey: "",
                leftText: "None",
                centerText: "1+",
                rightText: "2+",
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        return {
            uniqueFilterId,
            filterComponent: multiGenericFilter,
            displayLabel: "Has assignment...",
            filterKey: "",
            subfilters: [triplet],
            allFilterKeys: ["is_assigned", "has_more_than_one_assignment"],
            computeFilterKeyFromSubfilters: (filters) => filterKeyMapping[filters.get(tripletId)],
            computeFilterValueFromSubfilters: (filters) => valueMapping[filters.get(tripletId)],
            computeSubfilterValuesFromParent: (filterKey, value) => {
                return {
                    [tripletId]: Object.keys(filterKeyMapping)
                        .filter((key) => filterKeyMapping[key] === filterKey)
                        .find((key) => valueMapping[key] === value),
                }
            },
            serializationKey: toggleGenericFilter.defaultProps.serializationKey,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterPacEligibilityFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            displayLabel: "PAC Eligibilities",
            filterComponent: searchifySelectGenericFilter,
            filterKey: "for_pac_eligibilities",
            placeholderText: "Search by PAC Eligibility...",
            selectComponent: LedgerSettingsSelect,
            uniqueFilterId: "supporterPacEligibilityFilter",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const SupporterPacEligibleFilter = (ledgerSettingsId) =>
    createCustomToggleFilter({
        uniqueFilterId: "supporterPacEligibleToggleFilter",
        displayLabel: "PAC Eligible",
        filterKeyMapping: {
            true: "for_pac_eligibilities",
            false: "exclude_pac_eligible",
        },
        valueMapping: {
            true: ledgerSettingsId,
            false: ledgerSettingsId,
        },
    })

export class SupporterPacHybridEligibleFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        displayLabel: "PAC Eligible",
        falseText: "No",
        filterComponent: toggleGenericFilter,
        filterKey: "for_pac_hybrid_eligibilities",
        isNullable: true,
        trueText: "Yes",
        uniqueFilterId: "supporterPacHybridEligibleFilter",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterAssociatedWithPacFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: searchifySelectGenericFilter,
        uniqueFilterId: "supporterAssociatedWithPacFilter",
        filterKey: "for_pac_supporters_associated_with",
        dataTypeLabel: "PAC",
        displayLabel: "PAC",
        selectComponent: PacSelect,
        permissions: [DjangIO.app.models.PermissionType.pac_hybrid],
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterPacConditionalGivingLevel extends Component<FilterComponentProps> {
    static defaultProps = {
        displayLabel: "Conditional Giving Level",
        filterComponent: textGenericFilter,
        filterKey: "pac_conditional_giving_level__iexact",
        placeholderText: "Search by conditional giving level...",
        uniqueFilterId: "supporterPacConditionalGivingLevel",
        permissions: [DjangIO.app.models.PermissionType.qpac_v1, DjangIO.app.models.PermissionType.pac_hybrid],
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterHasSelectedCharityFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        displayLabel: "Has Selected a Charity",
        falseText: "No",
        filterComponent: toggleGenericFilter,
        filterKey: "has_selected_charity",
        isNullable: true,
        trueText: "Yes",
        uniqueFilterId: "supporterHasSelectedCharityFilter",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterSelectedCharityNameFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        displayLabel: "Charity Name",
        filterComponent: textGenericFilter,
        filterKey: "selected_charity_name",
        placeholderText: "Search by charity name...",
        uniqueFilterId: "supporterSelectedCharityNameFilter",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const createSupporterSelectedCharityDateFilter = (args) =>
    class SupporterSelectedCharityDateFilter extends Component<FilterComponentProps> {
        static get defaultProps() {
            const uniqueFilterId = `${args.uniqueFilterId}Filter`
            const gteId = `${args.uniqueFilterId}GteFilter`
            const lteId = `${args.uniqueFilterId}LteFilter`

            const DateGteFilter = class SelectedCharityDatePickerStartFilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: datePickerGenericFilter,
                    uniqueFilterId: gteId,
                    filterKey: "",
                    displayLabel: "Date From",
                    isSubSubfilter: true,
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }

            const DateLteFilter = class SelectedCharityDatePickerEndFilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: datePickerGenericFilter,
                    uniqueFilterId: lteId,
                    filterKey: "",
                    displayLabel: "Date To",
                    isSubSubfilter: true,
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }

            return {
                ...args,
                allFilterKeys: ["selected_charity_date"],
                displayLabel: "Charity Selection Date",
                filterComponent: multiGenericFilter,
                filterKey: "selected_charity_date",
                uniqueFilterId,
                subfilters: [[DateGteFilter, DateLteFilter]],
                computeFilterKeyFromSubfilters: (filters) => "selected_charity_date",
                computeFilterValueFromSubfilters: (filters) => {
                    const gte = filters.get(gteId)
                    const lte = filters.get(lteId)

                    if (!gte && !lte) {
                        return undefined
                    }

                    const params = {} as Record<string, any>
                    if (gte) {
                        params.date_from = gte
                    }
                    if (lte) {
                        params.date_to = lte
                    }
                    return JSON.stringify(params)
                },
                serializationKey: "generic",
            }
        }

        render() {
            const FilterComponent = this.props.filterComponent
            return <FilterComponent {...this.props} />
        }
    }

export class AssignedByUserFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "assignedByUserFilter",
            filterKey: "is_assigned_by",
            displayLabel: "Assigned by...",
            dataTypeLabel: "Users",
            searchifyFLV: UserFilterableListView,
            selectComponent: UserSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AssignedByUserToMeFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "assignedByUserToMeFilter",
            filterKey: "is_assigned_to_me_by",
            displayLabel: "Assigned to me by...",
            dataTypeLabel: "Users",
            searchifyFLV: UserFilterableListView,
            selectComponent: UserSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const createListFilter = (type) =>
    createSelectToggleMultiFilter({
        uniqueFilterId: "inList",
        displayLabel: "Is in my lists...",
        dataTypeLabel: "Lists",
        getSearchifyFLV: () => NewListFilterableListView,
        selectComponent: ListSelect,
        filterKeyMapping: {
            true: "in_list_or",
            false: "in_list_and",
        },
        searchifyPermanentFilter: { data_type: type },
    })

export const createNotInListFilter = (type) =>
    createSelectToggleMultiFilter({
        uniqueFilterId: "notInList",
        displayLabel: "Is not in my lists...",
        dataTypeLabel: "Lists",
        getSearchifyFLV: () => NewListFilterableListView,
        selectComponent: ListSelect,
        filterKeyMapping: {
            true: "not_in_list_or",
            false: "not_in_list_and",
        },
        searchifyPermanentFilter: { data_type: type },
    })

const UnconnectedManuallyChangedInListFilter = (props) => {
    const FilterComponent = props.filterComponent
    const showFilter = props.showManuallyChangeInListFilter
    return Boolean(showFilter) && <FilterComponent {...props} />
}

// this filter should only be shown when editing a List (that is, navigating from Lists to Powersearch)
// this structure is needed to retrieve the previous route from the application state which is used to determine if we are coming from the Lists page
export const ManuallyChangedInListFilter = connect(
    createStructuredSelector({ showManuallyChangeInListFilter: selectShowManuallyChangedInListFilter }),
)(UnconnectedManuallyChangedInListFilter)
// @ts-expect-error - defaultProps doesn't actually exist on the class
ManuallyChangedInListFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "listItemsChangedManually",
    filterKey: "in_list_manually",
    enumItems: DjangIO.app.userdata.types.ManuallyChangedListIds.items(),
    sortBy: enumValueSort,
}

export function generateIssueAlignmentFilter({ alignmentTypes, displayLabel, filterKey, uniqueFilterId }) {
    return createSelectToggleMultiFilter({
        uniqueFilterId,
        displayLabel,
        enumLabel: "With Alignment...",
        enumHelpText: "Filter results by their Alignment on a given issue.",
        dataTypeLabel: "Issues",
        getSearchifyFLV: () => IssueManagementFilterableListView,
        selectComponent: IssueManagementSelect,
        filterKeyMapping: {
            true: `${filterKey}_or`,
            false: `${filterKey}_and`,
        },
        enumItems: alignmentTypes,
    })
}

export class UnsubscribedEmailFilter extends Component<FilterComponentProps> {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "unsubscribedEmail",
        filterKey: "unsubscribed_from_bulk_emails",
        trueText: "Unsubscribed",
        falseText: "Subscribed",
        inverted: true,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ReceivedOutboxEmailFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "receivedEmail",
            filterKey: "received_bulk_email",
            displayLabel: "Received Email",
            dataTypeLabel: "Email",
            searchifyFLV: BulkEmailFilterableListView,
            selectComponent: BulkEmailSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class OpenedOutboxEmailFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "openedEmail",
            filterKey: "opened_bulk_email",
            displayLabel: "Opened Email",
            dataTypeLabel: "Email",
            searchifyFLV: BulkEmailFilterableListView,
            selectComponent: BulkEmailSelect,
            helpText:
                "Combined count of Top Pixel Open (initial_open) OR Bottom Pixel Open (open) OR Click Event (click).",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DidNotOpenOutboxEmailFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "didNotOpenEmail",
            filterKey: "did_not_open_bulk_email",
            displayLabel: "Did Not Open Email",
            dataTypeLabel: "Email",
            searchifyFLV: BulkEmailFilterableListView,
            selectComponent: BulkEmailSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ClickedLinkOutboxEmailFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "clickedLinkEmail",
            filterKey: "clicked_bulk_email",
            displayLabel: "Clicked Link Email",
            dataTypeLabel: "Email",
            searchifyFLV: BulkEmailFilterableListView,
            selectComponent: BulkEmailSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DidNotClickLinkOutboxEmailFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "didNotClickEmail",
            filterKey: "did_not_click_bulk_email",
            displayLabel: "Did Not Click Link Email",
            dataTypeLabel: "Email",
            searchifyFLV: BulkEmailFilterableListView,
            selectComponent: BulkEmailSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class RepliedOutboxEmailFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "repliedToEmail",
            filterKey: "replied_to_bulk_email",
            displayLabel: "Replied to Email",
            dataTypeLabel: "Email",
            searchifyFLV: BulkEmailFilterableListView,
            selectComponent: BulkEmailSelect,
            helpText: "We can only record replies for email domains that have routing turned on.",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DidNotReplyOutboxEmailFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "didNotReplyToEmail",
            filterKey: "did_not_reply_to_bulk_email",
            displayLabel: "Did Not Reply to Email",
            dataTypeLabel: "Email",
            searchifyFLV: BulkEmailFilterableListView,
            selectComponent: BulkEmailSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class LegislativeSessionFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "legSession",
            filterKey: "in_sessions",
            displayLabel: "Legislative Session",
            dataTypeLabel: "Legislative Session",
            searchifyFLV: LegislativeSessionSearchifyFLV,
            selectComponent: LegSessionSelect,
            regions: federalAndStates,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class CommitteeMentionFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "committeeMentionFilter",
            filterKey: "about_committee",
            dataTypeLabel: "Committees",
            regions: federalAndStates,
            searchifyFLV: CommitteeFilterableListView,
            selectComponent: CommitteeSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillMentionFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "billMentionFilter",
            filterKey: "about_bill",
            dataTypeLabel: "Bills",
            regions: federalAndStates,
            searchifyFLV: BillFilterableListView,
            selectComponent: BillSelect,
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class VoteMentionFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "voteMentionFilter",
            filterKey: "about_vote",
            dataTypeLabel: "Votes",
            regions: federalAndStates,
            searchifyFLV: VoteFilterableListView,
            selectComponent: VoteSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AmendmentMentionFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "amendmentMentionFilter",
            filterKey: "about_amendment",
            dataTypeLabel: "Amendments",
            regions: federalRegions,
            searchifyFLV: AmendmentFilterableListView,
            selectComponent: AmendmentSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class OfficialMentionFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "officialMentionFilter",
            filterKey: "about_person",
            dataTypeLabel: "Officials",
            searchifyFLV: OfficialFilterableWithoutCampaignFinanceListView,
            selectComponent: OfficialWithoutCampaignFinanceSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PressMentionFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "pressMentionFilter",
            filterKey: "about_person",
            dataTypeLabel: "Press Contacts",
            searchifyFLV: PressContactFilterableListView,
            selectComponent: PressContactSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class IssueMentionFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "issueMentionFilter",
            filterKey: "about_issue",
            dataTypeLabel: "Issues",
            regions: federalAndStates,
            searchifyFLV: IssueSearchifyFLV,
            selectComponent: IssueSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const AssignmentTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
AssignmentTypeFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    enumItems: PropTypes.array,
    enumGroups: PropTypes.array,
    displayLabel: PropTypes.string,
    sortBy: PropTypes.func,
}
AssignmentTypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "assignmentTypeFilter",
    filterKey: "assignment_type__in",
    enumItems: DjangIO.app.userdata.types.AssignmentType.items(),
    sortBy: enumOrderSort,
}

const UnconnectedStanceFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    const enumItems = props.stanceOptions
    return <FilterComponent {...props} enumItems={enumItems} />
}
export const StanceFilter = connect(createStructuredSelector({ stanceOptions: selectStancesWithCustomLabels }))(
    UnconnectedStanceFilter,
)
// @ts-expect-error - defaultProps doesn't actually exist on the class
StanceFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "legislativeStance",
    filterKey: STANCE_FILTER_KEY,
    sortBy: enumOrderSort,
}

export const PriorityFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
PriorityFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    enumItems: PropTypes.array,
    enumGroups: PropTypes.array,
    displayLabel: PropTypes.string,
    sortBy: PropTypes.func,
}
PriorityFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "legislativePriority",
    filterKey: PRIORITY_FILTER_KEY,
    enumItems: DjangIO.app.userdata.types.LegislativePriorityType.region_supported_items(),
    sortBy: enumValueSort,
}

export const PriorityHasLabelFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
PriorityHasLabelFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    componentKey: PropTypes.string,
    enumItems: PropTypes.array,
    enumGroups: PropTypes.array,
    displayLabel: PropTypes.string,
    sortBy: PropTypes.func,
}
PriorityHasLabelFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "legislativePriority",
    componentKey: "has-label", // disambiguate during rendering since uniqueFilterId is shared
    filterKey: PRIORITY_FILTER_KEY,
    displayLabel: "Priority",
    enumItems: DjangIO.app.userdata.types.LegislativePriorityType.region_supported_items(),
    sortBy: enumValueSort,
}

// invisible filters -- used when segueing from a list to
// search.
export const AddedIdsFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
AddedIdsFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    invisible: PropTypes.bool,
}
AddedIdsFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "addedIdsFilter",
    filterKey: "added_ids",
    invisible: true,
}

export const DeletedIdsFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
DeletedIdsFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    invisible: PropTypes.bool,
}
DeletedIdsFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "deletedIdsFilter",
    filterKey: "deleted_ids",
    invisible: true,
}

export const OnlyIdsFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
OnlyIdsFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    invisible: PropTypes.bool,
}
OnlyIdsFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "onlyIdsFilter",
    filterKey: "id__in",
    invisible: true,
}

export const CurrentSearchifySelectionFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
CurrentSearchifySelectionFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    invisible: PropTypes.bool,
}
CurrentSearchifySelectionFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "currentSearchifySelectionFilter",
    filterKey: "current_searchify_selection",
    invisible: true,
}

export const StanceLastUserFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={UserFilterableListView} {...props} />
}
StanceLastUserFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
StanceLastUserFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "stanceLastUserFilter",
    filterKey: "stance_last_user",
    displayLabel: "Stance Taken By",
    dataTypeLabel: "Stance Taken By",
    selectComponent: UserSelect,
}

export const PriorityLastUserFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={UserFilterableListView} {...props} />
}
PriorityLastUserFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
PriorityLastUserFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "priorityLastUserFilter",
    filterKey: "priority_last_user",
    displayLabel: "Priority Taken By",
    dataTypeLabel: "Priority Taken By",
    selectComponent: UserSelect,
}

export const BillExcludeUSStatesFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
BillExcludeUSStatesFilter.defaultProps = {
    displayLabel: "Exclude US States",
    filterComponent: toggleGenericFilter,
    filterKey: "exclude_us_states",
    uniqueFilterId: "billExcludeUSStatesFilter",
}

export const ReviewedByTeamFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={TeamSearchifyFLV} {...props} />
}
ReviewedByTeamFilter.propTypes = {
    dataTypeLabel: PropTypes.string,
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    selectComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
}
ReviewedByTeamFilter.defaultProps = {
    dataTypeLabel: "Teams",
    filterComponent: searchifySelectGenericFilter,
    filterKey: "reviewed_by_teams",
    selectComponent: TeamSelect,
    uniqueFilterId: "reviewedByTeamFilter",
}

export const ReviewedByMeFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
ReviewedByMeFilter.defaultProps = {
    displayLabel: "Reviewed By Me",
    filterComponent: toggleGenericFilter,
    filterKey: "reviewed_by_me",
    uniqueFilterId: "reviewedByMeFilter",
}

export const ReviewedByOrgFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
ReviewedByOrgFilter.defaultProps = {
    displayLabel: "Reviewed By Anyone",
    filterComponent: toggleGenericFilter,
    filterKey: "reviewed_by_org",
    uniqueFilterId: "reviewedByOrgFilter",
}

export const ReviewedByUserFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} searchifyFLV={UserFilterableListView} />
}
ReviewedByUserFilter.defaultProps = {
    displayLabel: "Reviewed By...",
    filterComponent: searchifySelectGenericFilter,
    filterKey: "reviewed_by_users",
    selectComponent: UserSelect,
    uniqueFilterId: "reviewedByUserFilter",
    dataTypeLabel: "Users",
}

export const NotReviewedByUserFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} searchifyFLV={UserFilterableListView} />
}
NotReviewedByUserFilter.defaultProps = {
    displayLabel: "Not Reviewed By...",
    filterComponent: searchifySelectGenericFilter,
    filterKey: "not_reviewed_by_users",
    selectComponent: UserSelect,
    uniqueFilterId: "notReviewedByUserFilter",
    dataTypeLabel: "Users",
}

// invisible filters for segueing to search from tracking boards
export const InvisibleUnreviewedByCriteriaFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
InvisibleUnreviewedByCriteriaFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "invisibleUnreviewedByCriteriaFilter",
    filterKey: "is_unreviewed_by_criteria",
    invisible: true,
}

export const InvisibleExcludeFiltersFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
InvisibleExcludeFiltersFilter.defaultProps = {
    // becuase it's an invisible filter the filterComponent doesn't matter
    filterComponent: enumGenericFilter,
    uniqueFilterId: "invisibleExcludeFiltersFilter",
    filterKey: "exclude_filters",
    invisible: true,
}

export const InvisibleNotReviewedByTeamsFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
InvisibleNotReviewedByTeamsFilter.defaultProps = {
    // becuase it's an invisible filter the filterComponent doesn't matter
    filterComponent: enumGenericFilter,
    uniqueFilterId: "invisibleNotReviewedByTeamsFilter",
    filterKey: "not_reviewed_by_teams",
    invisible: true,
}

export const GeoshapeTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
GeoshapeTypeFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    enumItems: PropTypes.array,
    enumGroups: PropTypes.array,
    displayLabel: PropTypes.string,
    sortBy: PropTypes.func,
}
GeoshapeTypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "geoshapeTypeFilter",
    filterKey: "geo_shape_type__in",
    enumItems: DjangIO.app.geography.types.GeoShapeType.region_supported_items().filter(
        (item) => item.value !== DjangIO.app.geography.types.GeoShapeType.state.value,
    ),
    sortBy: enumLabelSort,
}

export const GeoshapeTypeForBriefBuilderFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
GeoshapeTypeForBriefBuilderFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    enumItems: PropTypes.array,
    enumGroups: PropTypes.array,
    displayLabel: PropTypes.string,
    sortBy: PropTypes.func,
}
GeoshapeTypeForBriefBuilderFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "geoshapeTypeFilterForBriefBuilder",
    filterKey: "geo_shape_type__in",
    enumItems: DjangIO.app.geography.types.GeoShapeType.region_supported_items().filter((item) => {
        const GeoShapeTypes = DjangIO.app.geography.types.GeoShapeType
        const invalidTypes: number[] = [
            GeoShapeTypes.state.value,
            GeoShapeTypes.composite_shape.value,
            GeoShapeTypes.zip_municipal.value,
            GeoShapeTypes.zip_county.value,
        ]
        return !invalidTypes.includes(item.value)
    }),
    sortBy: enumLabelSort,
}

export class PopulationStratumFilter extends Component<FilterComponentProps> {
    static get defaultProps() {
        const props = {
            filterComponent: enumGenericFilter,
            uniqueFilterId: "populationStratumFilter",
            filterKey: "source_population_strata",
            enumItems: DjangIO.app.geography.models.PopulationStratum.items(),
            enumGroups: DjangIO.app.geography.models.PopulationStratum.filter_groups,
            sortBy: enumValueDescendingSort,
            displayLabel: "City/County Population",
            regions: localRegions,
        }

        if (isFeatureEnabled("ff_school_board_orgs_and_officials")) {
            props["selectComponent"] = PopulationRangesSelect
        }

        return props
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const createOrderByFilter = ({ uniqueFilterId }) => {
    const OrderByFilter = (props) => {
        const FilterComponent = props.filterComponent

        return <FilterComponent {...props} />
    }
    OrderByFilter.defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId,
        filterKey: "ordering",
        invisible: true,
    }

    return OrderByFilter
}

export const createPACDonationFilter = (args) =>
    class PACDonationFilter extends Component<FilterComponentProps> {
        static get defaultProps() {
            const inputId = `${args.uniqueFilterId}MultiNumberInput`
            const tripletId = `${args.uniqueFilterId}MultiTriplet`

            const amountInput = class InputFilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: textGenericFilter,
                    uniqueFilterId: inputId,
                    filterKey: "",
                    placeholderText: "Enter an amount...",
                    keyboardType: "numeric",
                    shouldValidateInput: true,
                    validateTextInput: isValidAmountString,
                    errorMessage: "Please enter a valid number amount.",
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }

            const triplet = class TripletFilter extends Component<FilterComponentProps> {
                static defaultProps = {
                    filterComponent: tripletGenericFilter,
                    uniqueFilterId: tripletId,
                    filterKey: "",
                    initialValue: "",
                    isNullable: true,
                }

                render() {
                    const FilterComponent = this.props.filterComponent
                    return <FilterComponent {...this.props} />
                }
            }

            return {
                ...args,
                filterComponent: multiGenericFilter,
                uniqueFilterId: args.uniqueFilterId,
                displayLabel: args.displayLabel,
                filterKey: "",
                subfilters: [amountInput, triplet],
                allFilterKeys: Object.values(args.filterKeyMapping),
                computeFilterKeyFromSubfilters: (filters) => {
                    const key = args.filterKeyMapping[filters.get(tripletId)]
                    return key ? key : undefined
                },
                computeFilterValueFromSubfilters: (filters) => filters.get(inputId),
                computeSubfilterValuesFromParent: (filterKey, value) => {
                    return {
                        [inputId]: value,
                        [tripletId]:
                            Object.keys(args.filterKeyMapping).find((key) =>
                                filterKey.includes(args.filterKeyMapping[key]),
                            ) || "center",
                    }
                },
                serializationKey: "toggle",
            }
        }

        render() {
            const FilterComponent = this.props.filterComponent
            return <FilterComponent {...this.props} />
        }
    }
